// extracted by mini-css-extract-plugin
export default {"button":"button__pNqdI","icon":"icon__Oln9H","danger":"danger__n2voN","disabled":"disabled__6e-IH"};